import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../assets/css/custom.css";

import CardComponent from "./CardComponent.jsx";

class ExternalTools extends Component {
  // static contextTypes = {
  //   router: () => true,
  // }

  render() {
    return (
      <div className="extrnl-div">
        <Row className="normal  extrnal_btn ">
          <Col className="col-sm-3 column_no_border">
            <CardComponent
              title="SCV"
              link="https://connect.havi.com/app/scp"
              description="HAVI SCV provides data visibility for all system partners including Suppliers, Hub, DCs 
            and Restaurants that drives better decision making, faster responsiveness and more efficient collaboration"
              logo="havi"
              btnLink="link"
            />
          </Col>

          <Col className="col-sm-3 column_no_border">
            <CardComponent
              title="VSR"
              link="https://connect.havi.com/app/vsr"
              description="HAVI VSR provides a central virtual location that provides efficient and focused 
           situation / event management via a shared operations space, providing common visibility of reporting and resource material"
              logo="havi"
              btnLink="link"
            />
          </Col>

          <Col className="col-sm-3 column_no_border">
            <CardComponent
              title="Amabis"
              link="https://gsc.amabis-timeware.eu/login"
              description="McD Amabis tool is a web-based  portal that allows supplier to enter finished goods facility level capacity, actuals, 
           forecast and raw material related information which will be feed into McD CapCon tool for risk identification"
              logo="mcd"
              btnLink="link"
            />
          </Col>

          <Col className="col-sm-3 column_no_border">
            <CardComponent
              title="Capcon"
              link="https://contingency.mcd.com/"
              description="McD CapCon tool leverages the data provided by Amabis platform and other external data sources to evaluate capacity, geopolitical
             and import/export risks for both finished products and raw materials."
              logo="mcd"
              btnLink="link"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ExternalTools;
